import { createContext, useEffect, useMemo, useState } from "react";
import { AuthService } from "../services/AuthService";
import ApiService from "../services/ApiService";

// const LayoutContext = createContext(null);

const LayoutContext = createContext(null);


export const LayoutProvider = ({ children }) => {


  const [sidebarToggled, setSidebarToggler] = useState(false);



  const handleSidebar = (value) => {
    setSidebarToggler(value)
  }
  

  // const value = useMemo(
  //   () => ({
  //     sidebarToggled,
  //     handleSidebar,
  //   }),
  //   []
  // );

  const params = {
    sidebarToggled,
    handleSidebar,
  }
  return <LayoutContext.Provider value={params}>{children}</LayoutContext.Provider>;
};


export default LayoutContext;